
import { Options, Vue } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { IOverviewMessage } from '@/utils/types'
import { ITableColumn } from '@/utils/table'

@Options({})
export default class BaseTableComponent extends Vue {
  @Prop({ type: String, required: true })
  title!: string

  @Prop()
  description!: string

  @Prop({ type: Array, default: () => [] })
  rows!: IOverviewMessage[]

  @Prop({ type: Array, required: true })
  columns!: ITableColumn[]

  @Prop({ type: Object })
  summaryRow?: Record<string, number>

  initialPagination = {
    sortBy: 'desc',
    descending: false,
    page: 1,
    rowsPerPage: 31,
  }

  formatValue(column: ITableColumn, value: any): string {
    if (value === undefined || value === null) return ''

    if (column.format) {
      return column.format(value) as string
    }

    return value.toString()
  }
}
